<template>
    <div>
        
        <apexchart :height="500" width="100%" type="bar" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    props: {
        dataItemGraph: {
            type: Array,
            default: () => ([]),
        },
        seriesA: {
            type: Array,
            default: () => ([]),
        },
        seriesB: {
            type: Array,
            default: () => ([]),
        },
    },
    data: function () {
        return {
            chartOptions: {
                chart: {
                    id: 'vuechart-example',
                },
                colors: ['#FD8D14', '#F31559'],
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                xaxis: {
                    categories: this.dataItemGraph
                },
                // legend: {
                //     position: "right",
                //     verticalAlign: "top",
                //     containerMargin: {
                //         left: 35,
                //         right: 60
            },
            series: [
                {
                    name: 'จำนวนการมาสาย / ครั้ง',
                    data: this.seriesA
                },
                {
                    name: 'จำนวนการขาดงาน / ครั้ง',
                    data: this.seriesB
                },
            ],
        }
    },
};
</script>